import {
  SHOW_CASE_MANAGEMENT_MODAL,
  HIDE_CASE_MANAGEMENT_MODAL
} from './actions.js'

export const initialState = {
  showModal: false,
  dischargeDate: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SHOW_CASE_MANAGEMENT_MODAL:
      return {
        ...state,
        showModal: true
      }
    case HIDE_CASE_MANAGEMENT_MODAL:
      return {
        ...state,
        showModal: false
      }
    default:
      return state
  }
}
